/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popGemInfo.vue?vue&type=template&id=59a82e93"
import script from "./popGemInfo.vue?vue&type=script&lang=js"
export * from "./popGemInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports